import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lastFilters: null,
};

const dashboardFiltersSlice = createSlice({
  name: "dashboardFilters",
  initialState,
  reducers: {
    setDashboardFilters(state, action) {
      state.lastFilters = action.payload;
    },
    clearDashboardFilters(state) {
      state.lastFilters = null;
    },
  },
});

export const { setDashboardFilters, clearDashboardFilters } = dashboardFiltersSlice.actions;
export default dashboardFiltersSlice.reducer;
